import React from 'react';
import { Switch } from 'antd';
import "./index.scss"
import ComparisonView from './children/ComparisonView';
import { fetchTrendData } from './utils/fetchTrendData';

const TrendComparison = (props) => {

    // Turning the comparison off and on again costs nothing: the results stay
    // in the store and only Apply marks them stale. Without that check this
    // fired the whole trend fetch on every flip of the switch.
    const handleChangeTrendToggle = (value) => {
        props.handleChangeComparisonToggle({ value })
        if (value && !props.isTrendDataFetched) {
            fetchTrendData(props)
        }

    }

    return (
        <div className='cardwrapper'>
            <div className='comparison-wrapper'>
                <span>
                    <Switch checked={props.isTrendComparison} onChange={(value, data) => { handleChangeTrendToggle(value) }} />
                </span>
                <div className='comparison-wrapper__description'>
                    <span className='label-header'> Compare against earlier feedback</span>
                    <span className='label-description'> Each participant is matched to their own earlier 360 by email address.</span>
                </div>

            </div>

            {props.isTrendComparison && <ComparisonView />}

        </div>
    );
};

export default TrendComparison;
